/* Jacked Jeans — pre-launch lock page
   Countdown + Klaviyo signup (email / SMS) + Meta Lead event.
   Only runs on collections using the "prelaunch" template. */
(function () {
  'use strict';

  var root = document.querySelector('[data-prelaunch]');
  if (!root) return;

  var launchAt = parseInt(root.getAttribute('data-launch-at'), 10);
  var companyId = root.getAttribute('data-klaviyo-company');
  var listId = root.getAttribute('data-klaviyo-list');
  var revealOnLaunch = root.getAttribute('data-reveal-on-launch') === 'true';

  /* ---------------- Countdown ---------------- */
  function initCountdown() {
    if (!launchAt) return;
    var wrap = root.querySelector('[data-countdown]');
    if (!wrap) return;

    var els = {
      days: wrap.querySelector('[data-countdown-days]'),
      hours: wrap.querySelector('[data-countdown-hours]'),
      minutes: wrap.querySelector('[data-countdown-minutes]'),
      seconds: wrap.querySelector('[data-countdown-seconds]')
    };
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };

    function tick() {
      var remaining = launchAt - Math.floor(Date.now() / 1000);

      if (remaining <= 0) {
        clearInterval(timer);
        onLaunched();
        return;
      }
      els.days.textContent = pad(Math.floor(remaining / 86400));
      els.hours.textContent = pad(Math.floor((remaining % 86400) / 3600));
      els.minutes.textContent = pad(Math.floor((remaining % 3600) / 60));
      els.seconds.textContent = pad(remaining % 60);
    }

    wrap.hidden = false;
    tick();
    var timer = setInterval(tick, 1000);
  }

  function onLaunched() {
    var reveal = document.querySelector('[data-prelaunch-reveal]');
    if (revealOnLaunch && reveal) {
      root.hidden = true;
      reveal.hidden = false;
    } else {
      // No products staged to reveal — reload so the shopper sees whatever is now live.
      window.location.reload();
    }
  }

  /* ---------------- Signup ---------------- */
  function subscribe(form) {
    var email = (form.querySelector('[name="email"]') || {}).value || '';
    var phoneField = form.querySelector('[name="phone"]');
    var phone = phoneField ? phoneField.value.trim() : '';
    var consentField = form.querySelector('[name="sms_consent"]');
    var smsConsent = consentField ? consentField.checked : false;

    var attributes = { email: email.trim() };
    if (phone) attributes.phone_number = phone;

    var subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (phone && smsConsent) {
      subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
      // Revision matters: on 2024-10-15 and earlier this endpoint rejects the
      // 'subscriptions' block with "not a valid field for the resource 'profile'".
      // Consent support for client-side subscriptions landed in a later revision.
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            // Shows in Klaviyo as the signup source, so drop signups are distinguishable.
            custom_source: root.getAttribute('data-meta-lead-name') || 'Pre-launch page',
            profile: {
              data: {
                type: 'profile',
                attributes: Object.assign({}, attributes, { subscriptions: subscriptions })
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    }).then(function (r) {
      // Klaviyo returns 202 with an empty body on success.
      if (r.status === 202 || r.ok) return true;
      return r.json().then(function (body) {
        var detail = body && body.errors && body.errors[0] && body.errors[0].detail;
        throw new Error(detail || 'Something went wrong. Please try again.');
      });
    });
  }

  function fireMetaLead() {
    if (root.getAttribute('data-meta-lead') !== 'true') return;

    var label = root.getAttribute('data-meta-lead-name') || 'Drop Early Access';

    // Two paths, because this store may run the Meta pixel directly or through GTM:
    // fire fbq when it is on the page, and always push a dataLayer event so a GTM tag
    // can be pointed at it. Both are wrapped so tracking can never block the confirmation.
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: label,
          content_category: 'Pre-launch signup'
        });
      }
    } catch (e) {}

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'prelaunch_signup',
        lead_source: 'Pre-launch lock page',
        content_name: label
      });
    } catch (e) {}

    // Third path: publish a Shopify customer event. A Custom Pixel in Shopify admin can
    // subscribe to this and forward the Lead to Meta from Shopify's own pixel sandbox,
    // which keeps working when a browser blocks connect.facebook.net directly.
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('prelaunch_signup', {
          lead_source: 'Pre-launch lock page',
          content_name: label
        });
      }
    } catch (e) {}
  }

  function initForm() {
    var form = root.querySelector('[data-prelaunch-form]');
    if (!form) return;

    var button = form.querySelector('[data-prelaunch-submit]');
    var message = form.querySelector('[data-prelaunch-message]');
    var originalLabel = button ? button.textContent.trim() : '';

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();

      var emailField = form.querySelector('[name="email"]');
      if (!emailField.value.trim() || !emailField.checkValidity()) {
        message.textContent = 'Please enter a valid email address.';
        message.className = 'jj-lock__message is-error';
        emailField.focus();
        return;
      }

      var phoneField = form.querySelector('[name="phone"]');
      if (phoneField && phoneField.hasAttribute('required') && !phoneField.value.trim()) {
        message.textContent = 'Please enter your mobile number.';
        message.className = 'jj-lock__message is-error';
        phoneField.focus();
        return;
      }

      if (!listId) {
        message.textContent = 'Signup is not connected yet. Please try again later.';
        message.className = 'jj-lock__message is-error';
        return;
      }

      button.disabled = true;
      button.textContent = 'Signing up...';
      message.textContent = '';
      message.className = 'jj-lock__message';

      subscribe(form)
        .then(function () {
          fireMetaLead();
          form.querySelector('.jj-lock__fields').hidden = true;
          var consent = form.querySelector('.jj-lock__consent');
          if (consent) consent.hidden = true;
          message.textContent = "You're on the list. Watch your inbox and texts for early access.";
          message.className = 'jj-lock__message is-success';
        })
        .catch(function (err) {
          message.textContent = err.message;
          message.className = 'jj-lock__message is-error';
          button.disabled = false;
          button.textContent = originalLabel;
        });
    });
  }

  initCountdown();
  initForm();
})();
